import { create } from 'zustand';

type CacheStore = {
  measurementMapSkip: boolean;
  setMeasurementMapSkip: (skipFetch: boolean) => void;
  actionsSkip: boolean;
  setActionsSkip: (skipFetch: boolean) => void;
  groupsSkip: boolean;
  setGroupsSkip: (skipFetch: boolean) => void;
  installationsSkip: boolean;
  setInstallationsSkip: (skipFetch: boolean) => void;
};

export const useCacheStore = create<CacheStore>()((set) => ({
  measurementMapSkip: true,
  setMeasurementMapSkip: (skipFetch: boolean) => set(() => ({ measurementMapSkip: skipFetch })),
  actionsSkip: true,
  setActionsSkip: (skipFetch: boolean) => set(() => ({ actionsSkip: skipFetch })),
  groupsSkip: true,
  setGroupsSkip: (skipFetch: boolean) => set(() => ({ groupsSkip: skipFetch })),
  installationsSkip: true,
  setInstallationsSkip: (skipFetch: boolean) => set(() => ({ installationsSkip: skipFetch })),
}));
